<template>
  <div id="wrap">
    <div id="joinPopup" :class="pageType === 'cart' ? 'cart_st' : 'join_st'">
      <!-- 본인 인증 START-->

      <div class="section full">
        <div class="inner flex-center">
          <!-- pc, tablet -->
          <div v-if="isPc || isTablet" class="logo_box">
            <router-link :to="{ name: 'store' }">
              <span data-v-1f234af1="" class="univ_logo">
                <img src="@/assets/images/hakji_web_logo.png" alt="" />
              </span>
            </router-link>
          </div>
          <!-- mobile -->
          <div v-if="isMobile && pageType !== 'cart'" class="logo_box">
            <router-link v-if="!isSignUpPage" :to="{ name: 'store' }">
              <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
            </router-link>
          </div>
          <div
            class="box_wrap"
            :class="{
              'pt_style': isSignUpPage,
              'non_pt': pageType === 'cart',
              'wid': routeName === 'order_successful'
            }"
          >
            <!-- SLOT INTO WRAPP HERE -->
            <slot />
            <!-- / SLOT -->
          </div>
          <!-- <div class="box tell_box" data-detail="clear">
            <div class="inquiry_text">
              <span class="c_icon ico_cer_inquiry"></span>
              <span>{{ $t('views.auth.join.joinstep2.3110') }}</span>
            </div>
            <div class="dl">
              <li>
                <div class="dd">
                  {{ $t('views.auth.join.joinstep2.2729')
                  }}<span>{{ $t('views.auth.join.joinstep2.4247') }}</span>
                </div>
              </li>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<style src="@/assets/css/page_join.css" scoped></style>
<style src="@/assets/css/page_member.css" scoped></style>
<script>
import responsiveMixin from '@/mixins/responsive'
export default {
  name: 'JoinWrapper',
  mixins: [responsiveMixin],
  props: {
    pageType: {
      type: String,
      default: null
    }
  },
  computed: {
    isSignUpPage() {
      return this.$route.path === '/join/sign_up'
    },
    routeName() {
      return this.$route.name
    }
  }
}
</script>

<style lang="scss" scoped>
#wrap {
  height: 100%;
  padding-bottom: 150px;
}
.flex-center {
  min-height: 80vh;
  flex-direction: column;
}
#joinPopup {
  position: inherit !important;
}
// .uinv_logo {
//   font-size: 30px;
//   line-height: 43px;
// }
.logo_box {
  text-align: center;
  padding: 0 0 54px 0;
  display: none;
}

.tell_box {
  background-color: #f0f5fa;
}
.box_wrap {
  &.wid {
    width: 980px;
  }
}
@media (max-width: 768px) {
  .flex-center {
    justify-content: flex-start;
  }
  #wrap {
    margin: 0;
  }
  .logo_box {
    padding: 0;
  }

  .tell_box {
    width: 100%;
  }

  .inquiry_text {
    width: 100%;
    text-align: center;
    margin-top: 20px !important;
  }
  .inquiry_text + .dl .dd {
    float: none;
    text-align: center;
  }
}
// @media (max-width: 480px) {
#wrap {
  padding-bottom: 0;
}
.flex-center {
  .logo_box {
    width: 100%;
    padding: 0;
    margin-bottom: 26px;
  }
}
.univ_logo {
  img {
    image-rendering: auto;
  }
}
// }
@media (max-width: 480px) {
  .flex-center {
    min-height: 100vh;
    .logo_box {
      display: block;
      > a {
        display: block;
        width: 160px;
        height: 31px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .box_wrap {
    &.non_pt {
      padding: 0;
    }
  }
}
// max-height
@media (max-height: 667px) {
  .flex-center {
    .logo_box {
      margin-bottom: 20px;
    }
  }
}
</style>
